<template>
    <div class="saleOriginal print">
        <div class="title">{{title}}</div>
        <div class="companyBox clearfix">
            <div class="company">收货公司:{{customer_name}}</div>
            <div class="companyTime">日期:{{sales_time}}</div>
        </div>
        <div class="flexTable">
            <div class="th">
                <div class="td tda">序号</div>
                <div class="td tdc">品名</div>
                <div class="td tdb">捆包号</div>
                <div class="td tdd">长度(m)</div>
                <div class="td tde">厚度(mm)</div>
                <div class="td tdf">宽度明细cm</div>
                <div class="td tdi">总宽度</div>
                <div class="td tdg">片数</div>
                <div class="td tdg">立方m³</div>
                <div class="td tdh">合计</div>
            </div>
            <div class="contentBox" v-for="(a,aIndex) in data" :key="aIndex">
                <div class="contentMain">
                    <div class="breed">{{a.breed}}</div>
                    <div class="listBox">
                        <div class="listA" v-for="(b,bIndex) in a.list" :key="bIndex">
                            <div class="number">{{b.index}}</div>
                            <div class="bale_no">{{b.bale_no}}</div>
                            <div class="listBBox">
                                <div class="listB" v-for="(c,cIndex) in b.list" :key="cIndex">
                                    <div class="length">{{c.length}}</div>
                                    <div class="thickness">{{c.thickness}}</div>
                                    <div class="detail">{{c.detail}}</div>
                                    <div class="totalWidth">{{c.total_width}}</div>
                                    <div class="cube">{{c.pieces}}</div>
                                    <div class="cube">{{c.cube}}</div>
                                </div>
                            </div>
                            <div class="total">{{b.total}}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="content">
                    <div class="breed">{{a.breed}}</div>
                    <div class="listABox">
                        <div class="listA" v-for="(b,bIndex) in a.list" :key="bIndex">
                            <div class="number">{{b.index}}</div>
                            <div class="bale_no">{{b.bale_no}}</div>
                            <div class="listBBox">
                                <div class="listB" v-for="(c,cIndex) in b.list" :key="cIndex">
                                    <div class="length">{{c.length}}</div>
                                    <div class="listBBreed"></div>
                                    <div class="thickness">{{c.thickness}}</div>
                                    <div class="detail">{{c.detail}}</div>
                                    <div class="totalWidth">{{c.total_width}}</div>
                                    <div class="cube">{{c.pieces}}</div>
                                    <div class="cube">{{c.cube}}</div>
                                </div>
                            </div>
                            <div class="total">{{b.total}}</div>
                        </div>
                    </div>
                </div> -->
                <div class="totalAll">
                    <div class="totalAllTitle">小计</div>
                    <div class="totalAllValue">{{a.total}}</div>
                </div>
            </div>
        </div>
        <div class="totalBottom">总计：{{total}}</div>
        <div class="companyBoxBottom clearfix">
            <div class="company">发货公司:{{company_name}}</div>
            <div class="company">地址:{{company_address}}</div>
            <div class="company">电话:{{company_phone}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            id:"",
            data:[
                {
                    breed:"品名",
                    total:123,
                    list:[
                        {
                            total:213,
                            bale_no:"kb123123",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                                {length:121,thickness:333,detail:"123213,123123,123123",cube:222}
                            ]
                        },
                        {
                            total:213,
                            bale_no:"kb222222",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                            ]
                        },
                        {
                            total:213,
                            bale_no:"kb333333",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                                {length:121,thickness:333,detail:"123213,123123,123123",cube:222}
                            ]
                        }
                    ]
                },
                {
                    breed:"品名",
                    total:123,
                    list:[
                        {
                            total:213,
                            bale_no:"kb123123",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                                {length:121,thickness:333,detail:"123213,123123,123123",cube:222}
                            ]
                        },
                        {
                            total:213,
                            bale_no:"kb222222",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                            ]
                        },
                        {
                            total:213,
                            bale_no:"kb333333",
                            list:[
                                {length:123,thickness:123,detail:"123213,123123,123123",cube:123},
                                {length:121,thickness:333,detail:"123213,123123,123123",cube:222}
                            ]
                        }
                    ]
                }
            ],
            company_address: "",
            company_name: "",
            company_phone: "",
            customer_name: "",
            logo: "",
            sales_time: "",
            title: "",
            total: ""
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.print()
    },
    methods:{
        print(){
            this.postFuncLoading("/erp/order.print.inventory",{id:this.id},res=>{
                this.company_address = res.data.data.company_address;
                this.company_name = res.data.data.company_name;
                this.company_phone = res.data.data.company_phone;
                this.customer_name = res.data.data.customer_name;
                this.logo = res.data.data.logo;
                this.sales_time = res.data.data.sales_time;
                this.title = res.data.data.title;
                this.total = res.data.data.total;
                this.data = res.data.data.data;
                setTimeout(() => {
                    this.printFunc()
                }, 0);
            })
        },
        printFunc(){
            setTimeout(() => {
                if(!!window.netscape){
                    window.print()
                    setTimeout(()=>{window.close()}, 0);
                }else{
                    var tata=document.execCommand("print");
                    if(tata){  //点击取消后执行的操作
                        window.close()
                    }
                }
            }, 0);
        }
    }
}
</script>
<style scoped>
    div{box-sizing: border-box;}
    .saleOriginal{padding:0 5px;-webkit-print-color-adjust: exact;}
    .saleOriginal .title{width:100%;text-align: center;font-size: 16px;font-weight: 600;padding:10px 0;}
    .companyBox{padding-bottom:10px;}
    .companyBox .company{font-size: 12px;color:#000;font-weight: 600;float: left;}
    .companyBox .companyTime{font-size: 12px;color:#000;font-weight: 600;float: right;}
    .flexTable{border-bottom:1px solid #000;border-left:0;border-top:0;}
    .flexTable .th{display: flex;flex-direction:row;height:30px;}
    .flexTable .td{border:1px solid #000;border-bottom:0;border-right:0;background-color: #EBEDF3;font-size: 12px;display: flex;text-align: center;align-items: center;justify-content:center}
    .flexTable .tda{flex-basis: 50px;}
    .flexTable .tdb{flex-basis: 100px;}
    .flexTable .tdc{flex-basis: 80px;}
    .flexTable .tdd{flex-basis:50px;}
    .flexTable .tde{flex-basis:60px;}
    .flexTable .tdf{flex:1;}
    .flexTable .tdg{flex-basis:60px;}
    .flexTable .tdi{flex-basis:60px;}
    .flexTable .tdh{flex-basis:60px;border-right:1px solid #000;}
    .flexTable .content{display: flex;flex-direction: row;position: relative;}
    .flexTable .contentBox{position:relative;}
    .flexTable .breed{font-size: 12px;display: flex;justify-content: center;align-items: center;flex-basis: 80px;border:1px solid #000;border-bottom:0;border-left:0;position: absolute;top:0;left:52px;width:79px;height:calc(100% - 26px);background-color: #fff;}
    .listABox{display: flex;flex-direction:column;flex: 1;}
    .flexTable .listA{flex: 1;display: flex;flex-direction: row;}
    .flexTable .listA .number{font-size: 12px;display: flex;justify-content: center;align-items: center;flex-basis: 50px;border:1px solid #000;border-bottom:0;border-right:0;}
    .flexTable .bale_no{font-size: 12px;display: flex;justify-content: center;align-items: center;flex-basis: 180px;padding-left: 80px;border:1px solid #000;border-bottom:0;border-right:0;}
    .flexTable .listBBox{flex: 1;display: flex;flex-direction: column;}
    .flexTable .listB{flex: 1;display: flex;flex-direction: row;}
    /* .flexTable .totalWidth{flex: 1;display: flex;flex-direction: row;} */
    .flexTable .total{display: flex;justify-content: center;align-items: center;flex-basis: 60px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;border-right:1px solid #000;}
    .flexTable .listBBreed{flex-basis: 80px;border:1px solid #000;border-bottom:0;border-right:0;}
    .flexTable .length{display: flex;justify-content: center;align-items: center;flex-basis: 50px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;}
    .flexTable .thickness{display: flex;justify-content: center;align-items: center;flex-basis: 60px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;}
    .flexTable .detail{display: flex;align-items: center;flex:1;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;padding:5px 0;padding-left:10px;}
    .flexTable .totalWidth{display: flex;justify-content: center;align-items: center;flex-basis: 60px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;}
    .flexTable .cube{display: flex;justify-content: center;align-items: center;flex-basis: 60px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;}
    .totalAll{display: flex;background-color: #EBEDF3;position:relative;}
    .totalAllTitle{display: flex;justify-content: center;align-items: center;flex:1;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;}
    .totalAllValue{display: flex;justify-content: center;align-items: center;flex-basis:60px;border:1px solid #000;border-bottom:0;border-right:0;font-size: 12px;padding:5px 0;border-right:1px solid #000;}
    /* .companyBoxBottom{border:1px solid #000;border-top:0;} */
    .companyBoxBottom .company{width:33.33%;float: left;font-size: 12px;padding:5px 0;}
    .totalBottom{border:1px solid #000;border-top:0;padding:5px 0;text-align: center;font-size: 12px;}
</style>